angular.module('impactx.MenuDirectives').controller('ShutDownInfoCtrl', [
    '$scope',
    'ShutdownService',
    'TranslationService',
    ShutDownInfoCtrl]);

function ShutDownInfoCtrl($scope, ShutdownService, TranslationService) {
    $scope.shutdownService = ShutdownService;
    $scope.translations = TranslationService;
}